import AlertDialog from "@/src/components/atom/AlertDialog";
import { useTranslation } from "react-i18next";

interface TaskContainerDeleteAlertDialogProps {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  onOk: () => void;
}

function TaskContainerDeleteAlertDialog({
  open,
  onOpenChange,
  onOk,
}: TaskContainerDeleteAlertDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog
      open={open}
      title={t("task:detail.alert.deleteContainerTitle")}
      onOpenChange={onOpenChange}
      onOk={onOk}
      okText={t("task:detail.button.okButton")}
      cancelText={t("task:detail.button.cancelButton")}
    >
      {t("task:detail.alert.deleteContainerDescription")}
    </AlertDialog>
  );
}

export default TaskContainerDeleteAlertDialog;
